export default {
  musicalGenres: 'Gêneros Musicais',
  seeMore: 'Veja mais',
  artists: 'Artistas',
  songs: 'Canções',
  topMusicalGenres: 'Principais gêneros musicais',
  additionalGenres: 'Gêneros adicionais',
  topArtists: 'Melhores Artistas',
  additionalArtists: 'Artistas adicionais',
  topSongs: 'Principais músicas',
  additionalSongs: 'Canções adicionais',
  likes: 'Gosta',
  peopleLikes: 'As pessoas gostam',
  additionalLikes: 'Curtidas adicionais',
  peoplePerJourneyStatus: 'Pessoas por status de jornada'
}
